<template>
  <div class="partner-logo-gap">
    <div class="header-wrapper" v-if="selectedColumnSet == 5">
      <div class="top">
        <h2>Autoplay</h2>
        <a-switch :checked="logoData.carus_auto" @change="onChange($event, 'autoplay')" />
      </div>
      <div class="bottom">
        <p>Enable/disable autoplay function on your slider</p>
      </div>
    </div>
    <div class="header-wrapper" v-if="selectedColumnSet == 5">
      <div class="top">
        <h2>Controls</h2>
        <a-switch :checked="logoData.carus_control" @change="onChange($event, 'controls')" />
      </div>
      <div class="bottom">
        <p>Enable/disable controls to manually control your slider</p>
      </div>
    </div>
    <div class="wrapper">
      <div class="dropdown-wrap" v-if="selectedColumnSet == 8">
        <label>Grid elements per row</label>
        <a-select
          default-value="Select a value"
          style="width: 180px; border-radius: 2px"
          :value="logoData.grid_row"
          @change="handleChangeElPerRow($event, 'grid')"
          class="select"
        >
          <a-select-option value="3"> 3 </a-select-option>
          <a-select-option value="4"> 4 </a-select-option>
          <a-select-option value="5"> 5 </a-select-option>
        </a-select>
        <small>Select number of single grid elements per row.</small>
      </div>
      <div class="dropdown-wrap" v-if="selectedColumnSet == 8">
        <label>Gap</label>
        <a-select
          default-value="Select a value"
          style="width: 180px; border-radius: 2px"
          :value="logoData.grid_gap"
          @change="handleChangeElPerRow($event, 'gap')"
          class="select"
        >
          <a-select-option value="20px"> 20px </a-select-option>
          <a-select-option value="30px"> 30px </a-select-option>
          <a-select-option value="40px"> 40px </a-select-option>
        </a-select>
        <small>Select gap between grid elements.</small>
      </div>
      <div class="dropdown-wrap" v-if="selectedColumnSet == 5">
        <label>Visible slides per row</label>
        <a-select
          default-value="Select a value"
          style="width: 180px; border-radius: 2px"
          :value="logoData.carus_visible"
          @change="handleChangeElPerRow($event, 'slides')"
          class="select"
        >
          <a-select-option value="4"> 4 </a-select-option>
          <a-select-option value="5"> 5 </a-select-option>
          <a-select-option value="6"> 6 </a-select-option>
        </a-select>
        <small>Select number of visible slides per row.</small>
      </div>
      <div class="dropdown-wrap" v-if="selectedColumnSet == 5">
        <label>Gap</label>
        <a-select
          default-value="Select a value"
          style="width: 180px; border-radius: 2px"
          :value="logoData.carus_gap"
          @change="handleChangeElPerRow($event, 'gapCar')"
          class="select"
        >
          <a-select-option value="5px"> 5px </a-select-option>
          <a-select-option value="10px"> 10px </a-select-option>
          <a-select-option value="15px"> 15px </a-select-option>
          <a-select-option value="20px"> 20px </a-select-option>
          <a-select-option value="30px"> 30px </a-select-option>
          <a-select-option value="40px"> 40px </a-select-option>
        </a-select>
        <small>Select gap between slide elements</small>
      </div>
      <div class="dropdown-wrap" v-if="selectedColumnSet == 5">
        <label>Autoplay speed</label>
        <a-select
          default-value="Select a value"
          style="width: 180px; border-radius: 2px"
          :value="logoData.carus_speed"
          @change="handleChangeElPerRow($event, 'autoplaySpeed')"
          class="select"
        >
          <a-select-option value="1s"> 1s </a-select-option>
          <a-select-option value="2s"> 2s </a-select-option>
          <a-select-option value="3s"> 3s </a-select-option>
          <a-select-option value="4s"> 4s </a-select-option>
          <a-select-option value="5s"> 5s </a-select-option>
          <a-select-option value="6s"> 6s </a-select-option>
        </a-select>
        <small>Select speed for autoplay functionality</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedColumnSet: {
      type: Number,
    },
    logosObj: {
      type: Object,
    },
  },
  data() {
    return {
      logoData: null,
    };
  },
  created () {
    this.logoData = JSON.parse(JSON.stringify(this.logosObj));
  },
  watch: {
    logosObj: {
      deep: true,
      handler () {
        this.logoData = JSON.parse(JSON.stringify(this.logosObj));
      },
    },
  },
  methods: {
    handleChangeElPerRow(value, dropdown) {
      console.log(`selected ${value}`);
      if (dropdown == "grid") {
        this.logoData.grid_row = value;
      }
      if (dropdown == "gap") {
        this.logoData.grid_gap = value;
      }
      if (dropdown == "slides") {
        this.logoData.carus_visible = value;
      }
      if (dropdown == "gapCar") {
        this.logoData.carus_gap = value;
      }
      if (dropdown == "autoplaySpeed") {
        this.logoData.carus_speed = value;
      }
      if (dropdown == "autoplaySpeed") {
        this.logoData.carus_speed = value;
      }
      this.$emit("partnerLogoSettings", this.logoData);
    },
    onChange(value, button) {
      if (button == "autoplay") {
        this.logoData.carus_auto = value;
      }
      if (button == "controls") {
        this.logoData.carus_control = value;
      }
      this.$emit("partnerLogoSettings", this.logoData);
    },
  },
};
</script>

<style lang='scss' scoped>
.partner-logo-gap {
  .header-wrapper {
    max-width: 800px;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 500px;
      padding: 32px 0 14px 0;
      h2 {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        margin: 0;
        line-height: 21px;
        color: #001529;
      }
    }
    .bottom {
      margin: 0 0 32px 0;
      p {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #001529;
      }
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 650px;
    margin: 25px 0;
    .dropdown-wrap {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      label {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 22px;
        color: #001529;
      }
      small {
        font-family: Roboto;
        font-style: italic;
        font-weight: normal;
        font-size: 12px;
        line-height: 22px;
        color: #b2bac7;
        max-width: 165px;
      }
    }
  }
}
</style>

<style>
.select {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #001529;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 2px;
  height: 40px;
}
</style>